import React, { useState } from 'react';
import s from './s.module.less';
import OnboardingStepContainer from '../OnboardingStepContainer';
import RadioOption from '../RadioOption';
import ActionButtons from '../ActionButtons';

interface PatientVolumeStepProps {
    onPatientVolumeChange?: (patientVolume: string) => void;
    onBack?: () => void;
    onNext?: () => void;
    onExit?: () => void;
    currentStep?: number;
    totalSteps?: number;
    initialPatientVolume?: string;
}

const patientVolumeOptions = [
    { id: '5-20-patients', label: '5–20 new patients / month' },
    { id: '20-50-patients', label: '20–50 new patients / month' },
    { id: '50-100-patients', label: '50–100 new patients / month' },
    { id: '100-plus-patients', label: '100+ new patients / month' },
];

export default function PatientVolumeStep({
    onPatientVolumeChange,
    onBack,
    onNext,
    onExit,
    currentStep = 5,
    totalSteps = 7,
    initialPatientVolume = '',
}: PatientVolumeStepProps) {
    const [selectedVolume, setSelectedVolume] = useState<string>(initialPatientVolume);

    const handleVolumeChange = (volumeId: string) => {
        setSelectedVolume(volumeId);

        if (onPatientVolumeChange) {
            onPatientVolumeChange(volumeId);
        }
    };

    return (
        <>
            <OnboardingStepContainer
                currentStep={currentStep}
                totalSteps={totalSteps}
                title="How many new patients would you like to add each month?"
                subtitle="Please select your target monthly volume."
                showBackButton
                onBack={onBack}
            >
                <div className={s.optionsContainer}>
                    {patientVolumeOptions.map((option) => (
                        <RadioOption
                            key={option.id}
                            id={option.id}
                            label={option.label}
                            checked={selectedVolume === option.id}
                            onChange={handleVolumeChange}
                        />
                    ))}
                </div>
            </OnboardingStepContainer>

            <ActionButtons
                showBack
                showNext={false}
                currentStep={currentStep}
                onBack={onBack}
            />
        </>
    );
}
